import { render, staticRenderFns } from "./AnimatedProductNavIcon.vue?vue&type=template&id=3b6556b0&scoped=true"
import script from "./AnimatedProductNavIcon.vue?vue&type=script&lang=js"
export * from "./AnimatedProductNavIcon.vue?vue&type=script&lang=js"
import style0 from "./AnimatedProductNavIcon.vue?vue&type=style&index=0&id=3b6556b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6556b0",
  null
  
)

export default component.exports